import { useState, useRef } from "react";
import type { JSX } from "react/jsx-runtime";
import FooterTabButton, { type FooterTab } from "./FooterTabButton.tsx";
import FooterTabPanel from "./FooterTabPanel.tsx";

type Props = {
  tabs: FooterTab[];
};

function FooterTabs({ tabs }: Props): JSX.Element {
  const [activeTab, setActiveTab] = useState(0);
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);

  function onSelectTab(tabIndex: number): void {
    let newActiveTab = tabIndex;
    if (tabIndex < 0) {
      newActiveTab = tabs.length - 1;
    } else if (tabIndex >= tabs.length) {
      newActiveTab = 0;
    }
    setActiveTab(newActiveTab);
    tabRefs.current[newActiveTab]?.focus();
  }

  return (
    <>
      <div
        role="tablist"
        aria-label="Registerkarten im Footer"
        className="relative m-none mb-xsmall list-none border-b border-utilitySubdued p-none text-center"
      >
        {tabs.map((tab, index) => (
          <FooterTabButton
            key={tab.id}
            tab={tab}
            tabIndex={index}
            isActive={index === activeTab}
            onSelectTab={onSelectTab}
            ref={(element: HTMLButtonElement | null): void => {
              tabRefs.current[index] = element;
            }}
          />
        ))}
      </div>
      {tabs.map((tab, index) => (
        <FooterTabPanel key={tab.id} tab={tab} isActive={index === activeTab} />
      ))}
    </>
  );
}

export default FooterTabs;
